import { getAllCourses, postAccountVerify, bookCourse } from "@/api/tac";

export default {
  getAllCourses({ commit }) {
    commit("REQUEST_ALL_COURSES");

    const from = new Date().toISOString();
    const upcomingSunday = new Date();
    upcomingSunday.setDate(new Date().getDate() + (14 - new Date().getDay()));
    upcomingSunday.setHours(23, 0, 0, 0);
    const to = upcomingSunday.toISOString();

    return getAllCourses({
      from,
      to,
    })
      .then((response) => {
        commit("SUCCESS_ALL_COURSES", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to get all courses:", err);
        commit("FAILED_ALL_COURSES");
      });
  },
  postAccountVerify({ commit, rootState }) {
    commit("REQUEST_TOKEN");
    const payload = {
      lastname: rootState.session.authResult?.checkin[0]?.last_name || "",
      roomNumber: rootState.session.authResult.room || "",
      reservationId: "",
      confirmationId: "",
      accountName: "",
      propertyId: rootState.session.propertyId || "",
    };
    return new Promise((resolve, reject) => {
      postAccountVerify(payload)
        .then((response) => {
          if (response.code == 200) {
            commit("SUCCESS_TOKEN", response.token);
            resolve();
          } else {
            commit("FAILED_TOKEN");
            reject();
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error("failed to get token:", err);
          commit("FAILED_TOKEN");
          reject(err);
        });
    });
  },
  bookCourse({ commit }, { courseId, numberOfPersons }) {
    commit("REQUEST_BOOK_COURSE");
    bookCourse({ courseId, numberOfPersons })
      .then((response) => {
        commit("SUCCESS_BOOK_COURSE", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to book course:", err);
        commit("FAILED_BOOK_COURSE");
      });
  },
};
